import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.cleanBullets()
  }

  cleanBullets() {
    // Finde alle li-Elemente in Trix-Content und Prose
    const listItems = this.element.querySelectorAll('li')
    // In .prose zeigt CSS bereits ein Bullet via li::before – kein zweites (disc) setzen
    const isProse = this.element.classList.contains('prose') || this.element.closest('.prose')

    listItems.forEach(li => {
      // Hole den Text-Inhalt des li
      const text = li.textContent.trim()

      // Prüfe ob Text mit einem Bullet-Symbol beginnt (», •, ▸, -, *, ›, ‣, ◦, ⁃)
      const bulletSymbols = ['»', '•', '▸', '›', '‣', '◦', '⁃', '➤', '▪', '▫']
      const startsWithBullet = bulletSymbols.some(symbol => text.startsWith(symbol))

      if (startsWithBullet) {
        // Entferne Browser-Bullet (vermeidet Doppel-Bullet mit Zeichen im Text)
        li.style.listStyleType = 'none'
      } else if (isProse) {
        // In .prose nur CSS-Bullet (::before) anzeigen, kein Browser-disc
        li.style.listStyleType = 'none'
      } else {
        // Außerhalb von .prose: Browser-Bullet anzeigen
        li.style.listStyleType = 'disc'
      }
    })
  }
}
